export function GenrePill({ genre }) {
  return (
    <span className="rounded-full border border-blue-300/20 px-2 py-0.5 font-sans text-xs font-medium text-blue-100">
      {genre}
    </span>
  );
}
